import uuidv4 from 'uuid/v4';
import {
    BATCH_SET_UNREAD_COUNTS,
    DECREASE_UNREAD_COUNT,
    GROUP_NOTIFICATION_MSG_COUNT,
    INCREASE_UNREAD_COUNT,
    REDUCE_UNREAD_MESSAGE_COUNT,
    RESET_UNREAD_COUNT,
    RESET_UNREAD_FOR_USER,
    SET_UNREAD_COUNT,
    UNREAD_MESSAGE_DELETE,
    UNREAD_MESSAGE_UPDATE,
    UNREAD_USER_OBJ,
} from './Constants';

export const GroupNotificationCount = data => {
    return {
        type: GROUP_NOTIFICATION_MSG_COUNT,
        payload: {
            id: uuidv4(),
            data,
        },
    };
};

// New consolidated unread count action creators
export const IncreaseUnreadCount = data => ({
    type: INCREASE_UNREAD_COUNT,
    payload: {
        id: uuidv4(),
        data,
    },
});

export const DecreaseUnreadCount = data => ({
    type: DECREASE_UNREAD_COUNT,
    payload: {
        id: uuidv4(),
        data,
    },
});

export const SetUnreadCount = data => ({
    type: SET_UNREAD_COUNT,
    payload: {
        id: uuidv4(),
        data,
    },
});

export const ReduceUnreadMsgCount = data => {
    return {
        type: REDUCE_UNREAD_MESSAGE_COUNT,
        payload: {
            id: uuidv4(),
            data,
        },
    };
};

export const ResetUnreadForUser = data => ({
    type: RESET_UNREAD_FOR_USER,
    payload: {
        id: uuidv4(),
        data,
    },
});

export const UnreadCountUpdate = data => {
    return {
        type: UNREAD_MESSAGE_UPDATE,
        payload: {
            id: uuidv4(),
            data,
        },
    };
};

export const UnreadCountDelete = data => ({
    type: UNREAD_MESSAGE_DELETE,
    payload: {
        id: uuidv4(),
        data,
    },
});

export const UnreadUserObj = data => {
    return {
        type: UNREAD_USER_OBJ,
        payload: {
            id: uuidv4(),
            data,
        },
    };
};

export const ResetUnreadCount = () => {
    return {
        type: RESET_UNREAD_COUNT,
    };
};

/**
 * Batch set unread counts for multiple users (performance optimized)
 * @param {Object} unreadCountsMap - Map of userId to unread data
 *   Format: { userId: { count: number, unreadMsgId: string }, ... }
 */
export const BatchSetUnreadCounts = unreadCountsMap => ({
    type: BATCH_SET_UNREAD_COUNTS,
    payload: {
        id: uuidv4(),
        data: unreadCountsMap,
    },
});
